/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Works_HighlightInputs */

const en_heading_works_highlight = /** @type {(inputs: Heading_Works_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiments`)
};

const ar_heading_works_highlight = /** @type {(inputs: Heading_Works_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تجارب`)
};

const bn_heading_works_highlight = /** @type {(inputs: Heading_Works_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পরীক্ষা`)
};

const de_heading_works_highlight = /** @type {(inputs: Heading_Works_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimente`)
};

const es_heading_works_highlight = /** @type {(inputs: Heading_Works_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimentos`)
};

const fr_heading_works_highlight = /** @type {(inputs: Heading_Works_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expériences`)
};

const pt_heading_works_highlight = /** @type {(inputs: Heading_Works_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experimentos`)
};

const zh_heading_works_highlight = /** @type {(inputs: Heading_Works_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实验`)
};

const tr_heading_works_highlight = /** @type {(inputs: Heading_Works_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneyler`)
};

const ru_heading_works_highlight = /** @type {(inputs: Heading_Works_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксперименты`)
};

const pl_heading_works_highlight = /** @type {(inputs: Heading_Works_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksperymenty`)
};

/**
* | output |
* | --- |
* | "Experiments" |
*
* @param {Heading_Works_HighlightInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_works_highlight = /** @type {((inputs?: Heading_Works_HighlightInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Works_HighlightInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_works_highlight(inputs)
	if (locale === "bn") return bn_heading_works_highlight(inputs)
	if (locale === "de") return de_heading_works_highlight(inputs)
	if (locale === "es") return es_heading_works_highlight(inputs)
	if (locale === "fr") return fr_heading_works_highlight(inputs)
	if (locale === "pt") return pt_heading_works_highlight(inputs)
	if (locale === "zh") return zh_heading_works_highlight(inputs)
	if (locale === "tr") return tr_heading_works_highlight(inputs)
	if (locale === "ru") return ru_heading_works_highlight(inputs)
	if (locale === "pl") return pl_heading_works_highlight(inputs)
	return en_heading_works_highlight(inputs)
});